import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";

import { SurveyResponseWrapper } from "src/model/SurveyResponseWrapper";
import {SurveyDisplayEvent} from "../../model/analytics/SurveyDisplayEvent";

@Injectable()
export class WebSurveyProvider {
  surveyApiPath = `${window.location.origin}/survey-api`;
  constructor(
    private http: HttpClient) { }

  /** Save a new survey response to the server.
   *  @param surveyResponse - The response containing the user's answers.
   */
  saveAnswers(surveyResponse: SurveyResponseWrapper, patientId: string, surveyIdentifier: string, surveyId: string): Observable<SurveyResponseWrapper> {
    const endpointURL = `${this.surveyApiPath}/survey/${surveyId}/response`;

    const httpOptions = {
      headers: this.generateRequestHeader(patientId, surveyIdentifier, surveyId)
    };

    return this.http.post<SurveyResponseWrapper>(endpointURL, surveyResponse, httpOptions).pipe(
      tap(() => {
      }),
      catchError(err => {
        console.error(`Save answers failed. Error details: ${JSON.stringify(err)}`);
        return throwError(err);
      })
    );
  }

  generateAuthToken(patientId: string, surveyIdentifier: string, surveyId: string): string {
    const encodedAuthToken = btoa(`${patientId}:${surveyIdentifier}:${surveyId}`);

    return `Bearer ${encodedAuthToken}`;
  }

  generateRequestHeader(patientId: string, surveyIdentifier: string, surveyId: string): HttpHeaders {
    const headersObject = new HttpHeaders()
      .set("Authorization", this.generateAuthToken(patientId, surveyIdentifier, surveyId))
      .set("Content-Type", "application/json");

    return headersObject;
  }
}
